module.exports = __webpack_public_path__ + "static/media/USYGY100088.ccdc5df8.jpg";